export const BEACON_DIALOG = 'beacon'
export const GENERAL_DIALOG = 'general'

export const TIMEOUT_SEARCH = 1000
export const TEXT_EDITOR_CONTROLS = ['DONOTTRANSLATE', 'textCount']
export const TYPE_SEND_NOW = 'TYPE_SEND_NOW'
export const TYPE_SEND_SCHEDULE = 'TYPE_SEND_SCHEDULE'
export const MAX_PLACE_NAME_FOR_SMS = 38
export const ENABLED_AUTOMATED_CALL = 'enabledAutomatedCall'
export const DESCRIPTION_MAX_LENGTH = 10000
export const SMALL_TITLE_MAX_LENGTH = 40
export const TITLE_MAX_LENGTH = 200
export const BODY_MAX_LENGTH = 200
export const BEACON_DESCRIPTION_MAX_LENGTH = 3500

export const ACTION_NEW = 'new'
export const ACTION_EDIT = 'edit'
